
export const setCookie = (name: string, value: string) => {
    Office.context.roamingSettings.set(name, value);
    Office.context.roamingSettings.saveAsync()
}


